import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogRefreshLikedFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'REFRESH_SCREEN',
      analytics: {
        ACTION: 'PULL',
      },
    });
  }, [logAnalyticsEvent]);
};
